import React from 'react';
import ServicePage from '../components/ServicePage';
import img from '../assets/service1_1.jpeg';

const overview = [
  'Datacenter Consultancy & Architecture including design, planning, and optimization aligned to business needs.',
  'Server Consolidation, Virtualisation & Hyper-Converged Solutions to improve efficiency, scalability, and resource utilization.',
  'Private Cloud & High-Performance Compute (HPC) Solutions supporting enterprise, AI, analytics, and mission-critical workloads.',
  'TCO & ROI Assessment for IT Components to drive cost optimization and long-term value.',
  'Data Centre Management Solutions covering monitoring, operations, and performance optimization.'
];

const features = [
  { title: 'Server Infrastructure', text: 'High-performance servers with redundancy and failover capabilities' },
  { title: 'Power Management',      text: 'Uninterruptible power supply and backup generators' },
  { title: 'Cooling Systems',       text: 'Advanced cooling solutions for optimal temperature control' },
  { title: 'Cloud Integration',     text: 'Hybrid cloud solutions for flexibility and scalability' }
];

function DataCentreService() {
  return (
    <ServicePage
      title="Data Centre and Cloud Solutions"
      subtitle="Enterprise-grade infrastructure for mission-critical operations"
      img={img}
      imgAlt="Data Centre Solutions"
      overview={overview}
      features={features}
      backAnchor="data-centre"
    />
  );
}

export default DataCentreService;
